import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

import CommonNav from "../../../CommonNav";
import Footer from "../../../Footer";

import Loading from "../../../../lib/Loading";
import UploadImageToS3WithPhp from "../../../../lib/UploadImageToS3WithPhp";
import BuddibleSocket, { MsgIDList } from "../../../../lib/BuddibleSocket";
import Utilities from "../../../../lib/Utilities";
import CodeList from "../../../../lib/CodeList";
import { useTranslation } from "react-i18next";

const socket = new BuddibleSocket();
const util = new Utilities();
const codeList = new CodeList();

const _mClassName = "ReserveAIR";

let times = [];
for (let hour = 0; hour < 24; hour++) {
  hour = hour < 10 ? "0" + hour : hour;
  for (let min = 0; min < 60; min = min + 30) {
    times.push(
      `${hour}:${min === 0 ? "0" + min : min}~${
        min === 30
          ? Number(hour) + 1 < 10
            ? "0" + (Number(hour) + 1)
            : Number(hour) + 1
          : hour
      }:${min + 30 === 60 ? "00" : min + 30}`
    );
  }
}

let memo_files = [];
let dgNoteActive = 0;
let flexiBagActive = 0;
let emailCnt = 0;
let emailList = [];
let airline_logo = "";
let supplier_logo = "";

export default function ReserveAIR(props) {
  const { t, i18n } = useTranslation();
  const params = useParams();
  const [isLoading, setIsLoading] = useState(false);
  const [scheduleData, setScheduleData] = useState(null);
  const [loginInfo, setLoginInfo] = useState(null);
  const [isSuccessGetData, setIsSuccessGetData] = useState(true);
  const [isNeedUpdate, setIsNeedUpdate] = useState(false);
  const navigate = useNavigate();

  const $controller = {
    sba_SHIPPER_NM: useRef(),
    sba_BLNO: useRef(),
    sba_PRODUCT_NM: useRef(),
    sba_CNT: useRef(),
    sba_QUANTITIES: useRef(),
    sba_BRING_TIME: useRef(),
    sba_FILES: useRef(),
    sba_MEMO: useRef(),
    sba_CFS_CODE: useRef(),
  };

  useEffect(() => {
    i18n.changeLanguage(i18n.language);

    const userData = socket.getLocalDataSet(MsgIDList.EVENT_LOGIN_AUTO_SUCCESS);
    if (userData && userData["returnData"].length) {
      emailList[0] = userData["returnData"][0].user_id;
      setLoginInfo(userData["returnData"][0]);
      SELECT_SCHEDULE_DATA();
    }

    socket.addLocalEventListener(
      MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
      _mClassName,
      (b, n) => {
        if (!n) {
          codeList.Modal.current.alert(t("commonMSG.requiresLogin"), () => {
            window.location.replace();
          });
        }
        emailList[0] = userData["returnData"][0].user_id;
        setLoginInfo(n["returnData"][0]);
        SELECT_SCHEDULE_DATA();
      }
    );

    socket.addLocalEventListener(
      MsgIDList.EVENT_SOCKET_DATA_ERROR,
      _mClassName,
      (b, n) => {
        console.log("데이터 통신에러", n);
      }
    );

    return () => {
      times = [];
      memo_files = [];
      dgNoteActive = 0;
      flexiBagActive = 0;
      emailCnt = 0;
      emailList = [];
      airline_logo = "";
      supplier_logo = "";
      socket.removeLocalEventListener(
        MsgIDList.EVENT_LOGIN_AUTO_SUCCESS,
        _mClassName
      );

      socket.removeLocalEventListener(
        MsgIDList.EVENT_SOCKET_DATA_ERROR,
        _mClassName
      );
    };
  }, []);

  //스케쥴 정보 가져오기
  function SELECT_SCHEDULE_DATA() {
    const sm_IDX = params.hasOwnProperty("id") ? params.id : "";
    if (sm_IDX === "") {
      codeList.Modal.current.alert(t("commonMSG.invalidAccess"));
      window.history.back();
    }

    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule_air/JS_schedule_air_sub_select.php",
      msgID: msgID,
      data: {},
      sm_IDX: sm_IDX,
    };

    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          if (newData["returnData"].length > 0) {
            airline_logo = newData["returnData"][0].sm_FWD_LOGO.split("?")[0];
            supplier_logo =
              newData["returnData"][0].sm_PROVIDER_LOGO.split("?")[0];
            let tempData = {
              ...newData["returnData"][0],
            };
            let detailData = socket.getLocalDataSet(
              MsgIDList.EVENT_MOVE_RESERVE_AIR
            );
            setScheduleData({ ...tempData, ...detailData });
            setIsSuccessGetData(true);
          } else {
            codeList.Modal.current.alert(t("commonMSG.invalidAccess"), () => {
              window.history.back();
            });
          }
        } else {
          codeList.Modal.current.alert(t("commonMSG.error"));
        }
      }
    });
  }

  function fileUploadCallback(val) {
    if (!val.ret) {
      codeList.Modal.current.alert(
        t("schedule.air.reserve.msg.errorUploadFile")
      );
      return;
    }
    let dataList = [...memo_files];
    dataList.push(`${val.realFileName}?${val.fileName}`);
    memo_files = dataList;
    setIsNeedUpdate(!isNeedUpdate);
  }

  function deleteUploadFile(index) {
    memo_files.splice(index, 1);
    setIsNeedUpdate(!isNeedUpdate);
  }

  function addReplyEmail() {
    emailCnt += 1;
    setIsNeedUpdate(!isNeedUpdate);
  }

  function removeReplyEmail(index) {
    emailCnt -= 1;
    emailList.splice(index, 1);
    setIsNeedUpdate(!isNeedUpdate);
  }

  const createdEmailInput = () => {
    let temp = [];
    for (let i = 1; i <= emailCnt; i++) {
      temp.push(
        <div
          key={i}
          className="mb-1 d-flex flex-row justify-content-start align-items-center"
        >
          <input
            className="form-control mr-2"
            placeholder={t("commonMSG.enterEmail")}
            value={emailList[i]}
            onChange={(e) => {
              emailList[i] = e.target.value;
            }}
          />
          <button
            className="btn btn-danger m-0"
            onClick={() => {
              removeReplyEmail(i);
            }}
          >
            -
          </button>
        </div>
      );
    }
    return temp;
  };

  function checkValidation() {
    if ($controller.sba_SHIPPER_NM.current.value.trim() === "") {
      codeList.Modal.current.alert(t("schedule.air.reserve.msg.enterShipper"));
      $controller.sba_SHIPPER_NM.current.focus();
      return false;
    }
    if ($controller.sba_BLNO.current.value.trim() === "") {
      codeList.Modal.current.alert(t("schedule.air.reserve.msg.enterBL"));
      $controller.sba_BLNO.current.focus();
      return false;
    }
    if ($controller.sba_PRODUCT_NM.current.value.trim() === "") {
      codeList.Modal.current.alert(t("schedule.air.reserve.msg.enterProduct"));
      $controller.sba_PRODUCT_NM.current.focus();
      return false;
    }
    if ($controller.sba_CNT.current.value.trim() === "") {
      codeList.Modal.current.alert(t("schedule.air.reserve.msg.enterCnt"));
      $controller.sba_CNT.current.focus();
      return false;
    }
    if ($controller.sba_QUANTITIES.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.air.reserve.msg.enterQuantities")
      );
      $controller.sba_QUANTITIES.current.focus();
      return false;
    }
    if ($controller.sba_BRING_TIME.current.value.trim() === "") {
      codeList.Modal.current.alert(
        t("schedule.air.reserve.msg.enterBringTime")
      );
      $controller.sba_BRING_TIME.current.focus();

      return false;
    }

    return true;
  }

  function actionSave() {
    codeList.Modal.current.confirm(
      t("schedule.air.reserve.msg.confirmBooking"),
      (ret) => {
        if (ret) {
          if (checkValidation()) {
            let data = {
              sba_IDX_MAIN: scheduleData.sm_IDX,
              sba_COMP_CD: loginInfo.comp_cd,
              sba_COMP_NM: loginInfo.comp_nm,
              sba_USER_ID: loginInfo.user_id,
              sba_USER_NM: loginInfo.user_nm,
              sba_SHIPPER_NM: null,
              sba_BLNO: null,
              sba_PRODUCT_NM: null,
              sba_CNT: null,
              sba_QUANTITIES: null,
              sba_BRING_TIME: null,
              sba_FILES: memo_files.length > 0 ? memo_files.join("|") : "",
              sba_MEMO: null,
              sba_EMAIL: emailList.join("|"),
              sba_CFS_CODE: null,
              sba_STATUS: "N",
              sba_STATUS2: "A",
              sba_FLIGHT_DATE: util.getDateToFormat(
                scheduleData.realDate,
                "YYYY-MM-DD"
              ),
              sba_CREATE_USERID: loginInfo.user_id,
              sba_CREATE_COMPCD: loginInfo.comp_cd,
              sba_UPDATE_USERID: loginInfo.user_id,
              sba_UPDATE_COMPCD: loginInfo.comp_cd,
              sba_FWD_NO: scheduleData.sm_FWD_NO,
              sba_FWD_NM: scheduleData.sm_FWD_NM,
              sba_PROVIDER_CODE: scheduleData.sm_PROVIDER_CODE,
              sba_PROVIDER_ID: scheduleData.sm_PROVIDER_ID,
              sba_PROVIDER_SALES_ID: scheduleData.sm_PROVIDER_SALES_ID,
              sba_DEPARTURE_DATE: scheduleData.sm_DEPARTURE_DATE,
              sba_VESSEL: scheduleData.sm_VESSEL,
              sba_CARGO_YN: scheduleData.sm_CARGO_YN,
              sba_POL_CODE: scheduleData.sm_POL_CODE,
              sba_POD_CODE: scheduleData.sm_POD_CODE,
              sba_EXP_IMP: scheduleData.sm_EXP_IMP,
              sba_INFO_MON: scheduleData.sm_INFO_MON,
              sba_INFO_TUE: scheduleData.sm_INFO_TUE,
              sba_INFO_WED: scheduleData.sm_INFO_WED,
              sba_INFO_THU: scheduleData.sm_INFO_THU,
              sba_INFO_FRI: scheduleData.sm_INFO_FRI,
              sba_INFO_SAT: scheduleData.sm_INFO_SAT,
              sba_INFO_SUN: scheduleData.sm_INFO_SUN,
              sba_REMARK: scheduleData.sm_REMARK,
              //   --------------이메일에 사용되는 데이터
              sm_PROVIDER_NM: scheduleData.sm_PROVIDER_NM,
              FLIGHT_NAME: scheduleData.FLIGHT_NAME,
              AIR_FREIGHT_NO: scheduleData.AIR_FREIGHT_NO,
              sm_ORIGIN: scheduleData.sm_ORIGIN,
              sm_POL_CODE: scheduleData.sm_POL_CODE,
              DEPARTURE_TIME: scheduleData.DEPARTURE_TIME,
              sm_DEST: scheduleData.sm_DEST,
              sm_POD_CODE: scheduleData.sm_POD_CODE,
              AIRRIVE_TIME: scheduleData.AIRRIVE_TIME,
              AIR_FREIGHT_MEMO: scheduleData.AIR_FREIGHT_MEMO,
              sm_REMARK: scheduleData.sm_REMARK,
            };
            for (let key in $controller) {
              if ($controller[key].current)
                data[key] = $controller[key].current.value || "";
            }
            INSERT_RESERVE_SCHEDULE_AIR(data);
          }
        }
      }
    );
  }

  function INSERT_RESERVE_SCHEDULE_AIR(data) {
    const msgID = util.makeUUIDv4();
    const socketMsg = {
      file: "/schedule_booking_air/JS_schedule_booking_air_insert.php",
      msgID: msgID,
      data: {},
      ...data,
    };
    setIsLoading(true);
    socket.sendMessage(socketMsg, msgID, (beforeData, newData) => {
      if (newData) {
        if (newData["ret"]) {
          codeList.Modal.current.alert(t("commonMSG.success"));
          navigate(-1);
        } else {
          codeList.Modal.current.alert(t("commonMSG.error"));
        }
        setIsLoading(false);
      }
    });
  }

  return (
    <>
      {isLoading && <Loading />}
      <CommonNav />
      <main style={{ marginTop: 56, minHeight: "80vh", background: "#f9f9f9" }}>
        {isSuccessGetData && loginInfo && scheduleData && (
          <div className="container py-4">
            <div className="row m-0 p-0 mb-4">
              <div className="col-0 col-xl-2" />
              <div className="col-12 col-xl-8 mb-2">
                <div className="d-flex flex-row justify-content-between align-items-center px-2">
                  <p className="h5 font-weight-900">
                    {t("schedule.air.reserve.bookInfo")}
                  </p>
                  <p className="font-weight-bold">
                    {t("schedule.air.reserve.reservePerson")} : [
                    {loginInfo.comp_nm}]
                    {loginInfo.USER_NICK || loginInfo.user_nm}
                  </p>
                </div>
                <div className="shadow-sm rounded-lg p-3 bg-white">
                  <div className="p-2 mb-2 border-bottom">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.bookDate")}
                    </p>
                    <div className="d-flex flex-row align-items-center">
                      <p className="h6 font-weight-900 text-dark m-0">
                        {scheduleData.dateTxt || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="p-2 mb-2 border-bottom">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.airline")}
                    </p>
                    <div className="d-flex flex-row align-items-center">
                      {airline_logo && (
                        <div
                          className="mr-2"
                          style={{
                            width: 20,
                            height: 20,
                            background: `url(${airline_logo}) 50% 50% / contain no-repeat`,
                          }}
                        />
                      )}
                      <p className="h6 font-weight-900 text-dark m-0">
                        {scheduleData.sm_FWD_NM || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="p-2 mb-2 border-bottom">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.supplier")}
                    </p>
                    <div className="d-flex flex-row align-items-center">
                      {supplier_logo && (
                        <div
                          className="mr-2"
                          style={{
                            width: 20,
                            height: 20,
                            background: `url(${supplier_logo}) 50% 50% / contain no-repeat`,
                          }}
                        />
                      )}
                      <p className="h6 font-weight-900 text-dark m-0">
                        {scheduleData.sm_PROVIDER_NM || "-"}
                      </p>
                    </div>
                  </div>
                  <div className="p-2 mb-2 border-bottom">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.flightName")}
                    </p>
                    <div>
                      <p className="h6 font-weight-900 text-dark">
                        {scheduleData.FLIGHT_NAME}{" "}
                        {scheduleData.AIR_FREIGHT_NO
                          ? `[${scheduleData.AIR_FREIGHT_NO}]`
                          : ""}
                        {!scheduleData.FLIGHT_NAME &&
                          !scheduleData.AIR_FREIGHT_NO &&
                          "-"}
                      </p>
                    </div>
                  </div>
                  <div className="p-2 mb-2 border-bottom d-flex flex-row">
                    <div className="w-50">
                      <p className="h6 mb-2 text-freiscop font-weight-700">
                        {t("schedule.air.reserve.departure")}
                      </p>
                      <div>
                        <p className="h6 mb-1 font-weight-900 text-dark">
                          {scheduleData.sm_POL_CODE
                            ? `[${scheduleData.sm_POL_CODE}] `
                            : ""}
                          {scheduleData.sm_ORIGIN || "-"}
                        </p>
                        {scheduleData.DEPARTURE_TIME && (
                          <p className="h6 font-weight-900 text-danger">
                            {scheduleData.DEPARTURE_TIME}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="w-50">
                      <p className="h6 mb-2 text-freiscop font-weight-700">
                        {t("schedule.air.reserve.arrival")}
                      </p>
                      <div>
                        <p className="h6 mb-1 font-weight-900 text-dark">
                          {scheduleData.sm_POD_CODE
                            ? `[${scheduleData.sm_POD_CODE}] `
                            : ""}
                          {scheduleData.sm_DEST || "-"}
                        </p>
                        {scheduleData.AIRRIVE_TIME && (
                          <p className="h6 font-weight-900 text-danger">
                            {scheduleData.AIRRIVE_TIME}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="p-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.notice")}
                    </p>
                    <p className="h6 font-weight-900 text-dark">
                      {scheduleData.sm_REMARK || "-"}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* 품목 정보 */}
            <div className="row m-0 p-0 mb-4">
              <div className="col-0 col-xl-2" />
              <div className="col-12 col-xl-8 mb-2">
                <div className="px-2 mb-2">
                  <p className="h5 mb-1 font-weight-900">
                    {t("schedule.air.reserve.itemInfo")}
                  </p>
                  <div className="d-flex flex-row align-items-center font-weight-bold">
                    <p className="mr-2">
                      {t("schedule.air.reserve.itemInfoNotice")}
                    </p>
                    <span
                      className="d-inline-block bg-info-light mr-1"
                      style={{ height: 16, width: 50 }}
                    />{" "}
                    : {t("schedule.air.reserve.inputArea")}
                  </div>
                </div>
                <div className="shadow-sm rounded-lg p-3 bg-white">
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.shipperName")}
                    </p>
                    <div>
                      <input
                        className="w-100 border-0 bg-info-light p-2 rounded"
                        ref={$controller.sba_SHIPPER_NM}
                        placeholder={t(
                          "schedule.air.reserve.shipperPlaceholder"
                        )}
                      />
                    </div>
                  </div>
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      H B/L NO
                    </p>

                    <div>
                      <input
                        className="w-100 border-0 bg-info-light p-2 rounded"
                        ref={$controller.sba_BLNO}
                        placeholder={t("schedule.air.reserve.blPlaceholder")}
                      />
                    </div>
                  </div>
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.productName")}
                    </p>
                    <div>
                      <input
                        className="w-100 border-0 bg-info-light p-2 rounded"
                        ref={$controller.sba_PRODUCT_NM}
                        placeholder={t(
                          "schedule.air.reserve.productPlaceholder"
                        )}
                      />
                    </div>
                  </div>
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.cnt")}
                    </p>
                    <div>
                      <input
                        className="w-100 border-0 bg-info-light p-2 rounded"
                        ref={$controller.sba_CNT}
                        placeholder={t("schedule.air.reserve.cntPlaceholder")}
                      />
                    </div>
                  </div>
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.quantities")}
                    </p>
                    <div>
                      <input
                        className="w-100 border-0 bg-info-light p-2 rounded"
                        ref={$controller.sba_QUANTITIES}
                        placeholder={t(
                          "schedule.air.reserve.quantitiesPlaceholder"
                        )}
                      />
                    </div>
                  </div>
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.bringTime")}
                    </p>
                    <div>
                      <select
                        className="w-100 border-0 bg-info-light p-2 rounded"
                        ref={$controller.sba_BRING_TIME}
                      >
                        {times.map((time) => {
                          return (
                            <option key={time} value={time}>
                              {time}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                  </div>
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.attachment")}
                    </p>
                    <UploadImageToS3WithPhp
                      region={`mall/reserveAIR/${scheduleData.sm_IDX}`}
                      callback={(val) => {
                        fileUploadCallback(val);
                      }}
                    />
                    <div className="pt-2 px-1">
                      {memo_files.length > 0 &&
                        memo_files.map((file, index) => {
                          let splitData = file.split("?");
                          let fileLink = splitData[1];
                          let fileName = splitData[0];
                          return (
                            <div
                              key={fileLink + "_" + index}
                              className="d-flex flex-row align-items-center mb-1"
                            >
                              <span
                                className="cursor_pointer text-underline text-primary mr-2"
                                onClick={() => {
                                  window.open(
                                    fileLink,
                                    "_blank",
                                    "width=1200, height=800"
                                  );
                                }}
                              >
                                {fileName}
                              </span>
                              <button
                                className="btn btn-sm btn-danger px-2 py-1 font-size-07"
                                onClick={() => deleteUploadFile(index)}
                              >
                                {t("schedule.air.reserve.delete")}
                              </button>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 반입지 정보 */}
            <div className="row m-0 p-0 mb-4">
              <div className="col-0 col-xl-2" />
              <div className="col-12 col-xl-8 mb-2">
                <div className="px-2 mb-2">
                  <p className="h5 mb-1 font-weight-900">
                    {t("schedule.air.reserve.cfsInfo")}
                  </p>
                </div>
                <div className="shadow-sm rounded-lg p-3 bg-white">
                  <div className="p-2 mb-2 border-bottom">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      CFS Code
                    </p>
                    <div>
                      <input
                        className="border-0 h6 font-weight-900 text-dark mb-0"
                        ref={$controller.sba_CFS_CODE}
                        value={"040077140"}
                        readOnly={true}
                      />
                    </div>
                  </div>
                  <div className="p-2 mb-2">
                    <p className="h6 mb-2 text-freiscop font-weight-700">
                      {t("schedule.air.reserve.cfsDetail")}
                    </p>
                    <div className="h6 font-weight-900 text-dark mb-0">
                      {t("schedule.air.reserve.cfsAddr")}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Booking 요청 메모 */}
            <div className="row m-0 p-0 mb-4">
              <div className="col-0 col-xl-2" />
              <div className="col-12 col-xl-8 mb-2">
                <div className="px-2 mb-2">
                  <p className="h5 mb-1 font-weight-900">
                    {t("schedule.air.reserve.memoTitle")}
                  </p>
                </div>
                <div className="shadow-sm rounded-lg p-3 bg-white">
                  <textarea
                    className="form-control bg-info-light rounded border-0"
                    rows={5}
                    placeholder={t("schedule.air.reserve.memoPlaceholder")}
                    ref={$controller.sba_MEMO}
                  />
                </div>
              </div>
            </div>

            {/* Booking 정보 회신처 */}
            <div className="row m-0 p-0 mb-2">
              <div className="col-0 col-xl-2" />
              <div className="col-12 col-xl-8 mb-2">
                <div className="px-2 mb-2">
                  <p className="h5 mb-1 font-weight-900">
                    {t("schedule.air.reserve.replyTitle")}
                  </p>
                </div>
                <div className="shadow-sm rounded-lg p-3 bg-white">
                  <div className="row m-0 p-0">
                    <div className="col-4 m-0 p-0 h6 font-weight-700 text-freiscop">
                      {t("schedule.air.reserve.email")}
                    </div>
                    <div className="col-8 m-0 p-0">
                      <div className="mb-1 d-flex flex-row justify-content-start align-items-center">
                        <input
                          className="form-control mr-2"
                          readOnly={true}
                          value={loginInfo.user_id}
                        />
                        <button
                          className="btn btn-primary m-0"
                          onClick={() => {
                            addReplyEmail();
                          }}
                        >
                          +
                        </button>
                      </div>

                      {createdEmailInput()}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* 제출 버튼 */}
            <div className="row m-0 p-0 mb-4">
              <div className="col-0 col-xl-2" />
              <div className="col-12 col-xl-8 mb-2 text-right">
                <button
                  className="btn btn-outline-info px-4 mr-2"
                  onClick={() => {
                    actionSave();
                  }}
                >
                  {t("schedule.air.reserve.submit")}
                  <i className="fa-solid fa-arrow-up-from-bracket ml-1" />
                </button>
              </div>
            </div>
          </div>
        )}
        {(!isSuccessGetData || !loginInfo || !scheduleData) && (
          <div className="container text-center">
            <div className="margin_60">
              <div className="bg-freiscop-05 p-5 rounded">
                <p className="h6 font-weight-bold">
                  {t("schedule.air.reserve.msg.errorData")}
                </p>
                <button
                  className="btn btn-sm btn-info"
                  onClick={() => {
                    navigate(-1);
                  }}
                >
                  {t("schedule.air.reserve.goBack")}
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
